module.exports = {
  addSms: 'addSms',
  getSms: 'getSms',
  listSms: 'listSms',
  updateSms: 'updateSms',
};